<template>
    <div id="navBar">
        <nav id="nav">
            <div class="header_catch">
                <img src="../assets/img-header.png" alt="To Be a Good Company">
            </div>
            <div class="header_content">
                <a :href="DOMAIN+ '/ec/'" class="logo">
                    <img class="logo_accu" src="../assets/logo.svg" alt="新安東京海上產險" @click="iconActive = false"/>
                </a>
                <div class="bannerPC" v-if="windowWidth>=1280">
                    <div>
                        <ul id="menu">
                            <li v-for="(item, index) in menuList" :key="index" class="parentName">
                                <a @click.prevent="goUrl(item)" @mouseover="makeActive(item)" :class="'menu_' + item.className + '_accu'">{{ item.parentName }}</a>
                            </li>
                            <li class="logout">
                                <a v-if="jwtInfo != null" @click="logout"> 登出 </a>
                                <a v-else @click="login"> 登入 </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bannerMB" v-else>
                    <div class="link">
                        <div class="linkCon" :class="{ 'active': iconActive }">
                            <div >
                                <ul class="menu_m" v-for="(item, index) in menuList" @click="mobileChild(item)" :key="index">
                                    <li class="parentName"
                                        :class="{ 'active': item.isActive,'hasChild':item.hasChild !== null }">
                                        <router-link :to="item.parentUrl" v-if="item.routerLink" :class="'menu_' + item.className + '_accu'">{{ item.parentName }}</router-link>
                                        <a v-else :class="'menu_' + item.className + '_accu'">{{ item.parentName }}</a>
                                    </li>
                                    <li v-if="item.isActive">
                                        <div >
                                            <ul class="child " v-for="(childItem, index) in item.hasChild" :key="index">
                                                <li class="childTitle">{{ childItem.childTitle }}</li>
                                                <li v-for="(child, childIndex) in childItem.childA" :key="childIndex">
                                                    <a :class="'menu_' + child.className + '_accu'" :href="child.childLink" target="_blank">
                                                        {{ child.childName }}
                                                    </a>
                                                </li>
                                                <li v-if="childItem.childTitle ==='保單服務'" class="blueText"><div >加保險種</div></li>
                                                <li v-for="(child, childIndex) in childItem.childB" :key="childIndex">

                                                    <a :class="'menu_' + child.className + '_accu'" :href="child.childLink" target="_blank">
                                                        {{ child.childName }}
                                                    </a>
                                                </li>
                                                <li v-for="(child, childIndex) in childItem.childC" :key="childIndex">
                                                    <a :class="'menu_' + child.className + '_accu'" :href="child.childLink" target="_blank">
                                                        {{ child.childName }}
                                                    </a>
                                                </li>
                                                <li v-for="(child, childIndex) in childItem.childD" :key="childIndex">
                                                    <a :class="'menu_' + child.className + '_accu'" :href="child.childLink" target="_blank">
                                                        {{ child.childName }}
                                                    </a>
                                                </li>

                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                                <div class="logout">
                                    <a v-if="jwtInfo != null" @click="logout"> 登出 </a>
                                    <a v-else @click="login"> 登入 </a>
                                </div>
                            </div>
                        </div>
                        <div class="iconM" @click="iconChange" :class="{ 'active': iconActive }">
                            <div class="bar-top"></div>
                            <div class="bar-middle"></div>
                            <div class="bar-bottom"></div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div class="bannerPC" @mouseleave="showChild.value=''" :class="{ 'menuChild': showChild.value }" v-if="windowWidth>=1280">
            <div class="flex">
                <div :class="{'hasChild':showChild.value.length>1}" class="w-100" v-for="item in showChild.value"  :key="item">
                    <div class="childTitle">{{ item.childTitle }}{{item.length}}</div>
                    <div style="width: 100%; display: flex">
                        <div class="w-50" :class="{'w-25':item.childTitle==='常見問題'|| item.childTitle==='續保登入'}">
                            <div class="child" v-for="(child, childIndex) in item.childA" :key="childIndex">
                                <a :href="child.childLink" target="_blank" :class="'menu_' + child.className + '_accu'">
                                    {{ child.childName }}
                                </a>
                            </div>
                        </div>
                        <div class="w-50" :class="{'w-25':item.childTitle==='常見問題'|| item.childTitle==='續保登入'}">
                            <div v-if="item.childTitle ==='保單服務'" class="blueText child">加保險種</div>
                            <div class="child" v-for="(child, childIndex) in item.childB" :key="childIndex">
                                <a :href="child.childLink" target="_blank" :class="'menu_' + child.className + '_accu'">
                                    {{ child.childName }}
                                </a>
                            </div>
                        </div>
                        <div class="w-50" v-if="item.childTitle==='常見問題'" :class="{'w-25':item.childTitle==='常見問題'}">
                            <div class="child" v-for="(child, childIndex) in item.childC" :key="childIndex">
                                <a :href="child.childLink" target="_blank" :class="'menu_' + child.className + '_accu'">
                                    {{ child.childName }}
                                </a>
                            </div>
                        </div>
                        <div class="w-50" v-if="item.childTitle==='常見問題'" :class="{'w-25':item.childTitle==='常見問題'}">
                            <div class="child" v-for="(child, childIndex) in item.childD" :key="childIndex">
                                <a :href="child.childLink" target="_blank" :class="'menu_' + child.className + '_accu'">
                                    {{ child.childName }}
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cookie" v-if="showCookieBanner">
        <div class="container">
            <div>為提供您最佳個人化且即時的服務，本網站透過使用Cookie記錄與存取您的瀏覽使用訊息。當您繼續瀏覽(使用)本網站或關閉本視窗，即表示您同意Cookie技術支援。更多資訊請參閱<a href="https://www.tmnewa.com.tw/customize/legalstatement" target="_blank">隱私權保護聲明</a>。</div>
            <button class="btn" @click="checkCookie">我知道了</button>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, onUnmounted, onBeforeMount } from 'vue';
import Swal from "sweetalert2";
import UserStatus from "@/utils/userStatus";
import { useRouter } from "vue-router";
import apiConfig from '@/utils/apiConfig';

const router = useRouter();
const DOMAIN = process.env.VUE_APP_DOMAIN;
const memberCenter = apiConfig.policyMember;
const env = process.env.VUE_APP_ENV;
const cfPath = env === 'prod' ? '/ec/cf/' : '/ec/cf/!cf/';
const menuList = reactive([
    {
        parentName: "投保服務",
        parentUrl: '',
        className: "insure",
        isActive: false, // 手機menu
        hasChild: [
            {
                childTitle: "立即投保",
                childA: [
                    {
                        childName: "汽車險",
                        childLink: apiConfig.policyCar,
                        className: "insure_car"
                    },
                    {
                        childName: "機車險",
                        childLink: apiConfig.policyMoto,
                        className: "insure_motor"
                    },
                    {
                        childName: "傷害險",
                        childLink: apiConfig.policyAccident,
                        className: "insure_accident"
                    },
                    {
                        childName: "商店綜合險",
                        childLink: apiConfig.policyCf,
                        className: "insure_cf"
                    }

                ],
                childB:[
                    {
                        childName: "住宅火險",
                        childLink: apiConfig.policyFire,
                        className: "insure_fire"
                    },
                    {
                        childName: "國外旅平險",
                        childLink: apiConfig.policyOverseas,
                        className: "insure_overseas"
                    },
                    {
                        childName: "國內旅平險",
                        childLink: apiConfig.policyTaiwan,
                        className: "insure_taiwan"
                    },
                ]
            },
            {
                childTitle: "試算單登入",
                childA: [
                    {
                        childName: "汽車險",
                        childLink: apiConfig.policyCar + 'plan',
                        className: "spreadsheet_car"
                    },
                    {
                        childName: "機車險",
                        childLink: apiConfig.policyMoto + 'plan',
                        className: "spreadsheet_motor"
                    },
                ],
                childB: [
                    {
                        childName: "住宅火險",
                        childLink: apiConfig.policyFire + 'plan',
                        className: "spreadsheet_fire"
                    },
                    {
                        childName: "商店綜合險",
                        childLink: apiConfig.policyCf + 'plan',
                        className: "spreadsheet_cf"
                    },

                ]
            }
        ],
        routerLink: false,
    },
    {
        parentName: "續保登入",
        className: "renewal",
        isActive: false, // 手機menu
        parentUrl: '',
        hasChild: [
            {
                childTitle: "續保登入",
                childA: [
                    {
                        childName: "汽車險",
                        childLink: apiConfig.policyCar + 'renewal',
                        className: "renewal_car"
                    },
                    {
                        childName: "機車險",
                        childLink: apiConfig.policyMoto + 'renewal',
                        className: "renewal_motor"
                    },

                ],
                childB: [
                    {
                        childName: "傷害險",
                        childLink: memberCenter + 'policyList#accident',
                        className: "renewal_accident"
                    },
                    {
                        childName: "住宅火險",
                        childLink: memberCenter + 'policyList#fire',
                        className: "renewal_fire"
                    },
                ]

            }
        ],
        routerLink: false,
    },
    {
        parentName: "文件上傳/下載",
        className: "upload",
        parentUrl: '',
        isActive: false, // 手機menu
        hasChild: [
            {
                childTitle: "文件上傳",
                childA: [
                    {
                        childName: "汽車險",
                        childLink: memberCenter + 'policyList#car',
                        className: "upload_car"
                    },
                    {
                        childName: "機車險",
                        childLink: memberCenter + 'policyList#motor',
                        className: "upload_motor"
                    },
                    {
                        childName: "商店綜合險",
                        childLink: memberCenter + 'policyList#cf',
                        className: "upload_cf"
                    },
                ],
                childB: [
                    {
                        childName: "住宅火險",
                        childLink: memberCenter + 'policyList#fire',
                        className: "upload_fire"
                    },
                    {
                        childName: "旅平險",
                        childLink: memberCenter + 'login#travel',
                        className: "upload_travel"
                    },
                    {
                        childName: "傷害險",
                        childLink: memberCenter + 'login#accident',
                        className: "upload_accident"
                    },
                ]
            },
            {
                childTitle: "文件下載",
                childA: [
                    {
                        childName: "要保書",
                        childLink: memberCenter + 'policyList#car',
                        className: "upload_policyFile"
                    },
                    {
                        childName: "電子保單",
                        childLink: process.env.VUE_APP_DOMAIN + '/B2C_V2/commonweb/epolicy.aspx?fk=1e23e566771d4e33b3051ca4ceea37b1',
                        className: "upload_Epolicy"
                    },
                ],
                childB: [
                    {
                        childName: "車險電子式強制證",
                        childLink: process.env.VUE_APP_DOMAIN + '/b2c_v2/frontstage/certificatequery.aspx',
                        className: "upload_certificateQuery"
                    },
                    {
                        childName: "批改申請書及駕駛人名冊",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/contents/download.html',
                        className: "upload_file"
                    },
                ]
            }
        ],
        routerLink: false,
    },
    {
        parentName: "保戶服務",
        className: "holder",
        parentUrl: "",
        isActive: false, // 手機menu
        hasChild:[
            {
                childTitle: "保單服務",
                childA: [
                    {
                        childName: "保單查詢",
                        childLink: memberCenter,
                        className: "holder_search"
                    },
                    {
                        childName: "退保服務",
                        childLink: memberCenter,
                        className: "holder_surrender"
                    },
                    {
                        childName: "保單資料變更",
                        childLink: memberCenter,
                        className: "holder_data"
                    }
                ],
                childB: [
                    {
                        childName: "汽車險",
                        childLink: memberCenter + 'policyList#car',
                        className: "holder_add_car"
                    },
                    {
                        childName: "機車險",
                        childLink: memberCenter + 'policyList#motor',
                        className: "holder_add_motor"
                    },
                    {
                        childName: "住宅火險",
                        childLink: memberCenter + 'policyList#fire',
                        className: "holder_add_fire"
                    }
                ]
            },
            {
                childTitle: "理賠通報服務",
                childA: [
                    {
                        childName: "車險理賠服務平台",
                        childLink: (env === 'prod' || env === 'stage') ? "https://www.tmnewa.com.tw/b2c_v2/commonweb/claim/car/index.html" : "https://b2cweb-test.tmnewa.com.tw/!TMNewa.B2CWeb/commonweb/claim/car/index.html",
                        className: "holder_car_claim"
                    },
                    {
                        childName: "旅遊不便險理賠申報平台",
                        childLink: (env === 'prod' || env === 'stage') ? "https://www.tmnewa.com.tw/b2c_v2/commonweb/claim/travel/index.html" : "https://b2cweb-test.tmnewa.com.tw/!TMNewa.B2CWeb/commonweb/claim/travel/index.html",
                        className: "holder_travel_claim"
                    },
                ],
            }
        ],
        routerLink: false,
    },
    {
        parentName: "商品說明",
        isActive: false, // 手機menu
        parentUrl: process.env.VUE_APP_DOMAIN + '/ec/contents/insuresinfo.html',
        className: "member",
        hasChild: null,
        routerLink: false,
    },
    {
        parentName: "常見問題",
        className: "question",
        parentUrl: "",
        isActive: false, // 手機menu
        hasChild:[
            {
                childTitle: "常見問題",
                childA: [
                    {
                        childName: "汽車險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/vehicle/car/faq',
                        className: "qa_car"
                    },
                    {
                        childName: "機車險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/vehicle/motor/faq',
                        className: "qa_motor"
                    },
                ],
                childB: [
                    {
                        childName: "國外旅平險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/travel/overseas/#QA',
                        className: "qa_overseas"
                    },
                    {
                        childName: "國內旅平險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/travel/taiwan/#QA',
                        className: "qa_taiwan"
                    },
                ],
                childC:[
                    {
                        childName: "傷害險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/accident/#QA',
                        className: "qa_accident"
                    },
                    {
                        childName: "住宅火險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/house/faq',
                        className: "qa_fire"
                    },
                ],
                childD: [
                    {
                        childName: "商店綜合險",
                        childLink: process.env.VUE_APP_DOMAIN + '/ec/cf/faq',
                        className: "qa_cf"
                    },
                ]

            }
        ]
    },
    {
        parentName: "優質合作夥伴",
        isActive: false, // 手機menu
        parentUrl: process.env.VUE_APP_DOMAIN + '/ec/cooperation',
        hasChild: null,
        className: "partner",
        routerLink: false,
    },
    {
        parentName: "會員專區",
        isActive: false, // 手機menu
        parentUrl: memberCenter + 'policyList#accident',
        className: "member",
        hasChild: null,
        routerLink: false,
    },
]);

const jwtInfo = ref({}); // JWT
const showChild = reactive([]);
const iconActive = ref(false);
const windowWidth = ref(window.innerWidth);
const showCookieBanner = ref(false);

const initCookieConsent = () => {
    showCookieBanner.value = localStorage.getItem('cookieConsent') !== 'true';
};

const handleResize = () => {
    windowWidth.value = window.innerWidth;
    if (windowWidth.value >= 1280) {
        iconActive.value = false;
    }
};

const goUrl = (item) => {
    if (item.hasChild === null && item.routerLink === false) {
        window.open(item.parentUrl, '_blank');
    }
    showChild.value = item.hasChild;
};

const makeActive = (item) => {
    showChild.value = item.hasChild;
    if (item.hasChild === null) {
        showChild.value = null;
    }
}; // hover選單

const iconChange = () => {
    iconActive.value = !iconActive.value;
};

const mobileChild = (item) => {
    item.isActive = !item.isActive;
    if (item.hasChild === null && item.routerLink === false) {
        window.open(item.parentUrl, '_blank');
        iconActive.value = false;
    }
    if (item.routerLink === true) {
        window.location.reload();
        iconActive.value = false;
    }
    menuList.forEach(menu => {
        if (menu !== item) {
            menu.isActive = false;
        }
    });
};
const login = () => {
    sessionStorage.setItem("bannerLogin", true);
    router.push("/login");
    const linkCon = document.querySelector('.linkCon.active');
    if (linkCon) {
        linkCon.classList.remove('active');
    }
}
const logout = ()=>{
    let appKey = jwtInfo.value.appKey;
    jwtInfo.value = null;
    UserStatus.logout(appKey);

    Swal.fire({
        title: "登出成功",
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonText: '確認',
        html: '<img src="successmark.svg" alt="success"><p>您已登出成功</p>',
    }).then(()=>{
        iconActive.value = false;
        router.push("/");
    });
}
const body = document.body;

const checkAndToggleOverflow = () => {
    const linkCon = document.querySelector('.linkCon.active');
    if (linkCon) {
        body.style.overflowY = 'hidden';
    } else {
        body.style.overflowY = '';
    }
};
const checkCookie = () => {
    localStorage.setItem('cookieConsent', 'true');
    showCookieBanner.value = false;
};

// 監聽 DOM 變化
const observer = new MutationObserver(checkAndToggleOverflow);
observer.observe(body, { childList: true, subtree: true });

// 初始檢查
setInterval(checkAndToggleOverflow, 100); // 每 100 毫秒執行一次

const reLoadJwt = () => {
    jwtInfo.value = JSON.parse(localStorage.getItem("jwtInfo"));
}
defineExpose({ reLoadJwt  }) //父組件需使用
onBeforeMount(() => {
    window.addEventListener('resize', handleResize);
    handleResize();reLoadJwt();
    initCookieConsent();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

</script>
<style lang="scss">
.cookie {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.90);
    box-shadow:0 0 24px 0 rgba(0, 0, 0, 0.20);
    z-index: 1000;
    .container{
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    div {
        font-size: 16px;
        line-height: 150%;
        a {
            color: $blue-600;
            text-decoration: underline;
        }
    }

    .btn {
        background: $blue-700;
        width: 160px;
        min-width: 160px;
        max-width: 160px;
        flex: 0 0 160px;
        height: 40px;
        cursor: pointer;
        margin: 0;
        padding: 0;
        font-size: 16px;
    }
    .btn:hover {
        background: $blue-700;
    }
    @media screen and (max-width: $medium) {
        .container {
            padding: 20px;
        }
    }
    @media screen and (max-width: $small) {
        .container {
            flex-direction: column;
            align-items: flex-start;
            padding: 20px 10px;
        }
        .btn{
            width: 100%;
            min-width: 0;
            max-width: none;
            flex: 1 1 auto;
        }
    }
}

#navBar {
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    top: 0;
    z-index: 1000;
    width: 100%;
    .blueText{
        color: $blue-700 !important;
        font-weight: 700;
        font-size: 16px;
    }
    li{
        font-size: 18px;
        font-weight: bold;
    }
    a{
        text-decoration: none !important;
        color: $black-800;
        &:hover{
            color: $blue-600;
        }
    }
    .logout{
        a{
            width: 72px;
            height: 40px;
            border: 1px solid $blue-700 !important;
            color: $blue-700 !important;
            border-radius: 50px;
            font-weight: normal !important;
            font-size: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        a:hover{
            background: $blue-700;
            color: #fff !important;
        }
    }
    #nav {
        background-color: #fff;
        border-bottom: 1px solid $gray-400;
        z-index: 100;
        box-sizing: border-box;


        .header_catch {
            position: relative;
            width: 100%;
            height: 13px;
            background-image: linear-gradient(to right, #00b3fe, #039);
            img {
                position: absolute;
                top: 0;
                right: 0;
                height: 12px;
            }
        }
        .header_content {
            padding: 15px 30px 15px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo {
            float: left;
            width: 245px;
            img {
                display: block;
            }
        }
        @media screen and (max-width: $small) {
            background-position: left bottom;
        }
        @media screen and (max-width: $medium) {
            padding: 0;
        }
    }
    .bannerPC{
        .hasChild{
            padding-right: 20px;
        }
        a{
            padding: 0 10px;
        }
        .child a{
            padding: 0;
        }
        .w-100{
            width: calc(100% - 40px);

            &:only-child {
                width: calc(100% - 20px);
            }
        }
        .w-25{
            width: 25% !important;
        }
        .w-50{
            width: 50%;
        }
        .w-50:nth-child(1){
            padding-left: 14px;
        }
        .childTitle{
            padding: 0 0 10px 0 ;
        }
        .parentName a{cursor: pointer;}
        #menu {
            align-items: center;
        }
    }
    .menuChild {
        background: $mainColor;
        position: absolute;
        right: 30px;
        top: 94.5px;
        width: 900px;
        height: 200px;
        border-radius: 0 0 20px 20px;
        border: 1px solid $gray-400;
        z-index: 100;
        box-sizing: border-box;

        .flex{
            padding: 10px 0 0 20px;
        }

        a {
            color: #4F4F4F;
            display: inline-block;
            &:hover {
                color:$blue-600 ;
            }
        }
    }
    .bannerMB{
        display: none;
        .logout{
            margin-top: 50px;
            padding: 0 20px;
            border: 0;
            width: auto;
            a{
                width: auto;
                padding:  8px 0 ;
                display: block;
                border: 1px solid $blue-700;
                color: $blue-700;
                border-radius: 50px;
                font-weight: normal !important;
                font-size: 16px;
                text-align: center;
            }
        }
        .parentName{
            margin:20px 20px 0 20px;
            &.active{
                margin-bottom: 10px !important;
            }
            a{
                font-weight: 700 !important;
                line-height: 150%;
                font-size: 18px;
                cursor: pointer;
                :hover {
                    color: $blue-600;
                }
            }
        }
        .child{
            background: $blue-400;
            padding:0 20px 20px  ;
            li{
                padding: 0 0 10px 14px;
                &:first-child{
                    padding-left: 0 !important;
                }
                &:last-child {
                    padding-bottom: 0 !important;
                }
            }
            &:first-child {
                padding-top: 20px;
            }

            &:last-child {
                padding-bottom: 20px;
            }
            a {
                font-size: 16px;
                font-weight: 100;
            }
        }
        @media only screen and (max-width: $medium) {
            display: block !important;
            .linkCon{
                padding-bottom: 20px;
            }
        }
        .linkCon {
            background: #fff;
            height: calc(100vh - 95px);
            right: -650px;
            position: fixed;
            -webkit-transform: translateX(150%);
            -ms-transform: translateX(150%);
            transform: translateX(150%);
            box-sizing: border-box;
            overflow-y: auto;
            top: 96px;
            &.active {
                -webkit-transform: translateX(-650px);
                -ms-transform: translateX(-650px);
                transform: translateX(-650px);
                width: 100%;

            }
            li {
                &.hasChild {
                    background-image: url("../assets/arrowDown.png");
                    background-repeat: no-repeat;
                    background-position: right top 7px;
                    background-size: 20px;

                    &.active {
                        background-image: url("../assets/arrowUp.png");
                    }
                }
            }
        }

        .iconM {
            display: block;
            flex-flow: column wrap;
            justify-content: space-between;
            width: 24px;
            cursor: pointer;

            .bar-bottom, .bar-middle, .bar-top {
                width: 100%;
                height: 3px;
                background: $blue-700;
                border-radius: 10px;
                margin: 5px 0;
                transform-origin: right;
                transition: all .5s;
            }
        }
    }

    #menu {
        display: flex;
        li {
            //padding: 0 10px;
            border-right: 1px solid $gray-400;
            &:nth-last-of-type(-n+2) {
                border: 0;
            }
        }

    }
    .childTitle{
        font-size: 18px;
        font-weight: 700;
        line-height: 150%;
        color: $blue-700;
        border-bottom:1px solid $gray-400;
        padding: 10px 0;
        margin-bottom: 10px;
    }
    .childTitle::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 20px;
        background: $blue-700;
        border-radius: 5px;
        margin-right: 8px;
        //vertical-align: middle;
        position: relative;
        top: 4px; /* 調整此值以控制向上的距離 */

    }
    .child{
        font-size: 16px;
        padding-bottom: 10px;
        white-space: nowrap;
        padding-right: 10px;
    }
}
</style>
